// Seconds a call has waited in a call group, from its Redis queue entry's enqueueTime.
// enqueueTime is epoch seconds, but some entries arrive in milliseconds; read those as ms
// and never return a negative wait (clock skew). null when the entry has no usable time.
export function queueWaitSeconds(enqueueTime: unknown, nowSec: number): number | null {
  let t = parseInt(String(enqueueTime ?? ''), 10);
  if (!Number.isFinite(t) || t <= 0) return null;
  if (t > 1e11) t = Math.floor(t / 1000);
  return Math.max(0, nowSec - t);
}
